// @flow
import React, { Fragment } from 'react';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
import { Strong } from '@finect/tabular-core/Strong';
import { getAuthorBadges } from '@finect/front-core/Profiles';
import { IdentityCard } from '../../IdentityCard';
import { ServiceDetailItem, Unsold, PendingMessage, ButtonBlock } from '../partials';

export const AdvisersLeadsDetail = ({
  service,
  handleTransaction
}: {
  service: Object,
  handleTransaction: Function
}) => (
  <Fragment>
    {service.status === 'Unsold' ? (
      <Unsold>
        <p>
          Sentimos no poder ayudarte más, <Strong>no hemos encontrado asesores que se ajusten</Strong> a las necesidades
          que nos indicas. Según tu perfil, tenemos una <Strong>selección de empresas de gestión automatizada </Strong>
          que pueden ser de tu interés y ayudarte a cumplir los objetivos que nos has indicado.
        </p>

        <ButtonBlock>
          <ButtonLined href="http://bit.ly/2PbKtOb" as="a" width="auto">
            Ver selección
          </ButtonLined>
        </ButtonBlock>
      </Unsold>
    ) : service.status === 'MailedToUser' || service.status === 'Completed' ? (
      <Fragment>
        {service.advisers.map((item) => {
          const badges = getAuthorBadges(item);

          return (
            <ServiceDetailItem key={item.id}>
              <IdentityCard
                type="profile"
                entity={{
                  id: item.id,
                  subtype: item.subtype,
                  name: item.displayName,
                  icon: `/image/${item.icon}`,
                  alias: item.alias,
                  adviser: false,
                  company: badges.length ? badges.join(', ') : 'Asesor',
                  verified: false
                }}
                isRefuse={service.status === 'MailedToUser'}
                onRefuse={() => handleTransaction(item, service.id)}
              />
            </ServiceDetailItem>
          );
        })}
      </Fragment>
    ) : (
      <PendingMessage>
        <p>Aún estamos trabajando para encontrar los mejores asesores para ti.</p>
      </PendingMessage>
    )}
  </Fragment>
);
